import type { RefObject } from 'react';
import { useEffect, useEffectEvent, useLayoutEffect, useState } from 'react';

const SUB_PIXEL_ROUNDING_TOLERANCE = 1;

export const useIsOverflowing = (
  containerRef: RefObject<HTMLDivElement | null>
) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflowing = () => {
    if (containerRef.current) {
      const { scrollWidth, clientWidth } = containerRef.current;
      const updatedValue =
        scrollWidth - clientWidth > SUB_PIXEL_ROUNDING_TOLERANCE;
      if (updatedValue !== isOverflowing) {
        setIsOverflowing(updatedValue);
      }
    }
  };

  const handleResize = useEffectEvent(checkOverflowing);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    const container = containerRef.current;
    container?.addEventListener('scroll', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      container?.removeEventListener('scroll', handleResize);
    };
  }, [containerRef]);

  useLayoutEffect(checkOverflowing);

  return isOverflowing;
};
